var version;

version = '0.12.2';

module.exports = version;
